import axios from 'axios';

// Créer une instance Axios avec configuration par défaut
const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter automatiquement les headers à chaque requête
api.interceptors.request.use(
  (config) => {
    // Ajouter le token d'authentification
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Ajouter le club_id et club_slug pour le multi-tenant
    const clubId = localStorage.getItem('clubId');
    if (clubId) {
      config.headers['X-Club-Id'] = clubId;
    }
    const clubSlug = localStorage.getItem('clubSlug');
    if (clubSlug) {
      config.headers['X-Club-Slug'] = clubSlug;
    }

    // Ajouter l'identité utilisateur pour les vérifications de propriété
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    if (user) {
      config.headers['X-User-Id'] = user.id;
      config.headers['X-User-Role'] = user.role;
    }

    // Ajouter le mode demo si activé
    if (user && user.is_demo) {
      config.headers['X-Demo-Mode'] = 'true';
    }

    // App mono-langue « VBC Femenino » : espagnol forcé.
    config.headers['Accept-Language'] = 'es';

    // Ajouter la section par défaut aux params si non présente
    if (!config.params) {
      config.params = {};
    }
    if (!config.params.section) {
      config.params.section = process.env.REACT_APP_SECTION || 'hommes';
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Retry avec backoff exponentiel pour erreurs réseau et 5xx
const MAX_RETRIES = 3;
const RETRY_DELAY_MS = 1000;

function shouldRetry(error) {
  // Retry sur erreur réseau (pas de response)
  if (!error.response) return true;
  // Retry sur 5xx (erreur serveur)
  if (error.response.status >= 500) return true;
  // Retry sur 429 (rate limit)
  if (error.response.status === 429) return true;
  return false;
}

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

// Intercepteur pour gérer les erreurs de réponse
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;

    // Gérer les erreurs d'authentification (401) - pas de retry
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('clubId');
      localStorage.removeItem('clubSlug');
      localStorage.removeItem('language');
      window.location.href = '/login';
      return Promise.reject(error);
    }

    // Gérer les erreurs d'autorisation (403) - pas de retry
    if (error.response?.status === 403) {
      console.error('Accès non autorisé');
      return Promise.reject(error);
    }

    // Retry logic
    if (config && shouldRetry(error)) {
      config._retryCount = config._retryCount || 0;

      if (config._retryCount < MAX_RETRIES) {
        config._retryCount += 1;
        const backoff = RETRY_DELAY_MS * Math.pow(2, config._retryCount - 1);
        console.log(`Retry ${config._retryCount}/${MAX_RETRIES} après ${backoff}ms: ${config.method?.toUpperCase()} ${config.url}`);
        await delay(backoff);
        return api(config);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
